import { SERVER_URL } from '../../../helpers/Config';
import { history } from '../../../history';
import axios from 'axios';
import { setToken, removeToken } from '../../../helpers/Token';
import { toast } from 'react-toastify';
import { msConfig } from '../../../helpers/MicrosoftConfig';
import { PublicClientApplication } from '@azure/msal-browser';

export const logoutMS = async () => {
  const msObj = new PublicClientApplication({
    auth: {
      clientId: msConfig.appId,
      redirectUri: msConfig.redirectUri,
      authority: msConfig.authority,
      navigateToLoginRequestUrl: true,
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: true,
    },
  });

  let tokenResponse = await msObj.handleRedirectPromise();

  console.log('token on logout', tokenResponse);
  const config = {
    auth: {
      clientId: msConfig.appId,
      redirectUri: msConfig.redirectUri, // defaults to application start page
      postLogoutRedirectUri: msConfig.redirectUri,
    },
  };
  const myMsal = new PublicClientApplication(config);
  await myMsal.logoutPopup(config);
};

export const loginWithJWT = (user) => {
  return (dispatch) => {
    dispatch({
      type: 'AUTH_LOADING',
      payload: true,
    });
    axios
      .post(SERVER_URL + 'admins/login', user)
      .then((response) => {
        let loggedInUser;

        if (response.data && response.data.isSuccess) {
          loggedInUser = response.data.data.token;
          setToken(loggedInUser);
          console.log('user received');
          dispatch({
            type: 'LOGIN_WITH_JWT',
            payload: { loggedInUser, loggedInWith: 'jwt' },
          });
          dispatch({
            type: 'TOAST',
            payload: {
              text: 'Welcome',
              type: 'success',
            },
          });
          history.push('/dashboard');
        } else {
          dispatch({
            type: 'AUTH_LOADING',
            payload: false,
          });
          setTimeout(() => {
            logoutMS();
          }, 1500);
          dispatch({
            type: 'TOAST',
            payload: {
              text: response.data.message,
              type: 'error',
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        setTimeout(() => {
          logoutMS();
        }, 1500);
        toast.error('Wrong username or password');
        dispatch({
          type: 'AUTH_LOADING',
          payload: false,
        });
      });
  };
};

export const logoutWithJWT = () => {
  return (dispatch) => {
    dispatch({ type: 'LOGOUT_WITH_JWT', payload: {} });
    removeToken();
    //remove actually from session storage
    history.push('/pages/login');
  };
};
